<template>
    <el-dialog :visible.sync="openDialog" class="newDialog" width="1000px" top="20px" :title="title" :close-on-click-modal="false">
		<el-form label-width="150px" ref="form" :model="form" :rules="rules" size="small">
			<el-row>
				<el-col :span="12">
					<el-form-item label="创建时间" prop="createTime">
						<el-date-picker type="date" placeholder="选择日期" v-model="form.createTime"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="创建人" prop="createUser">
						<el-input v-model="form.createUser" placeholder="请输入创建人"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业名称" prop="name">
						<el-input v-model="form.name" placeholder="请输入企业名称"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="认证地区" prop="rzRegion">
						<el-select v-model="form.rzRegion" style="width: 100%" placeholder="请选择认证地区">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="统一社会信息代码" prop="tyShXxCode">
						<el-input v-model="form.tyShXxCode" placeholder="请输入统一社会信息代码"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="英文名称" prop="englishName">
						<el-input v-model="form.englishName" placeholder="请输入英文名称"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业简称" prop="qyShort">
					<el-input v-model="form.qyShort" placeholder="请输入企业简称"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="组织机构代码" prop="orgJgCode">
						<el-input v-model="form.orgJgCode" placeholder="请输入组织机构代码"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="邓白氏编码" prop="dbsCode">
						<el-input v-model="form.dbsCode" placeholder="请输入邓白氏编码"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业类型" prop="qyTyoe">
						<el-input v-model="form.qyTyoe" placeholder="请输入企业类型"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="纳税人标识" prop="taxpayerSign">
						<el-input v-model="form.taxpayerSign" placeholder="请输入纳税人标识"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="注册国家/地区" prop="country">
						<el-input v-model="form.country" placeholder="请输入注册国家/地区"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="详细地址" prop="address">
						<el-input v-model="form.address" placeholder="请输入详细地址"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="法定代表人" prop="legalPerson">
						<el-input v-model="form.legalPerson" placeholder="请输入法定代表人"/>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="注册资本" prop="zcCapital">
						<el-input-number v-model="form.zcCapital" controls-position="right" style="width: 100%"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="注册资本货币种类(万)" prop="zcCurrency">
						<el-input v-model="form.zcCurrency" placeholder="请输入注册资本货币种类(万)"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="建立日期" prop="foundDate">
						<el-date-picker type="date" placeholder="选择日期" v-model="form.foundDate"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="经营范围" prop="manageArea">
						<el-input v-model="form.manageArea" placeholder="请输入经营范围"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="营业执照图附件" prop="yyZzSrc">
						<el-upload class="upload-demo" :action="upload()" :show-file-list="false"
									accept=".xls,.xlsx,.doc,.docx,.pdf,application/msword" :on-success="handleAvatarSuccess"
									:before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
							<el-input v-model="form.yyZzSrc" placeholder="点击文本框上传(以上是登记信息)" readonly slot="trigger"/>
						</el-upload>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="主要身份" prop="zySf">
						<el-select v-model="form.zySf" style="width: 100%" placeholder="请选择主要身份">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="经营性质" prop="jyXz">
						<el-select v-model="form.jyXz" style="width: 100%" placeholder="请选择经营性质">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="行业类型" prop="hyType">
						<el-select v-model="form.hyType" style="width: 100%" placeholder="请选择行业类型">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="主营品类" prop="zyClass">
						<el-select v-model="form.zyClass" style="width: 100%" placeholder="请选择主营品类">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="送货服务范围" prop="shFwScope">
						<el-select v-model="form.shFwScope" style="width: 100%" placeholder="请选择送货服务范围">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="公司官网" prop="gsGw">
						<el-input v-model="form.gsGw" placeholder="请输入公司官网"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="公司Logo" prop="gsLogoSrc">
						<el-input v-model="form.gsLogoSrc" placeholder="请输入公司Logo"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="公司简介" prop="gsDetail">
						<el-input v-model="form.gsDetail" placeholder="请输入公司简介(以上是业务信息)"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="发票头" prop="invoiceHead">
						<el-input v-model="form.invoiceHead" placeholder="请输入发票头"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="税务登记号" prop="swDjh">
						<el-input v-model="form.swDjh" placeholder="请输入税务登记号"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开户行" prop="khhName">
						<el-input v-model="form.khhName" placeholder="请输入开户行"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开户行账号" prop="khhNumber">
						<el-input v-model="form.khhNumber" placeholder="请输入开户行账号"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="税务登记地址" prop="swDjDz">
						<el-input v-model="form.swDjDz" placeholder="请输入税务登记地址"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="税务登记电话" prop="swDjDh">
						<el-input v-model="form.swDjDh" placeholder="请输入税务登记电话"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收票人邮箱" prop="sprEmail">
						<el-input v-model="form.sprEmail" placeholder="请输入收票人邮箱"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收票人电话" prop="sprDh">
						<el-input v-model="form.sprDh" placeholder="请输入收票人电话(以上是开票信息)"/>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业性质" prop="qyXz">
						<el-select v-model="form.qyXz" style="width: 100%" placeholder="请选择企业性质">
							<el-option label="启用" value="0"></el-option>
							<el-option label="禁用" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="状态" prop="status">
						<el-radio-group v-model="form.status">
							<el-radio :label="0">启用</el-radio>
							<el-radio :label="1">停用</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
      	<span slot="footer" class="dialog-footer">
			<el-button @click="openDialog = false" size="small">取 消</el-button>
			<el-button type="primary" @click="submitForm" size="small">确 定</el-button>
		</span>
    </el-dialog>
</template>
<script>
import {
	supplierInfoList,
	addSupplierInfo,
	editSupplierInfo,
	delSupplierInfo,
	batchDelSupplierInfo,
	exportSupplierInfo,
} from '@/api/gys/supplierInfo.js'
export default {
    data(){
		return {
			title: "",
			openDialog: false,
			form: {},
			fileName: '',
			rules: {
				createTime: [{
					required: true,
					message: '请输入创建时间',
					trigger: 'blur'
				}],
				createUser: [{
					required: true,
					message: '请输入创建人',
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: '请输入企业名称',
					trigger: 'blur'
				}],
				rzRegion: [{
					required: true,
					message: '请输入认证地区',
					trigger: 'blur'
				}],
				tyShXxCode: [{
					required: true,
					message: '请输入统一社会信息代码',
					trigger: 'blur'
				}],
				englishName: [{
					required: true,
					message: '请输入英文名称',
					trigger: 'blur'
				}],
				qyShort: [{
					required: true,
					message: '请输入企业简称',
					trigger: 'blur'
				}],
				orgJgCode: [{
					required: true,
					message: '请输入组织机构代码',
					trigger: 'blur'
				}],
				dbsCode: [{
					required: true,
					message: '请输入邓白氏编码',
					trigger: 'blur'
				}],
				qyTyoe: [{
					required: true,
					message: '请输入企业类型',
					trigger: 'blur'
				}],
				taxpayerSign: [{
					required: true,
					message: '请输入纳税人标识',
					trigger: 'blur'
				}],
				country: [{
					required: true,
					message: '请输入注册国家/地区',
					trigger: 'blur'
				}],
				address: [{
					required: true,
					message: '请输入详细地址',
					trigger: 'blur'
				}],
				legalPerson: [{
					required: true,
					message: '请输入法定代表人',
					trigger: 'blur'
				}],
				zcCapital: [{
					required: true,
					message: '请输入注册资本',
					trigger: 'blur'
				}],
				zcCurrency: [{
					required: true,
					message: '请输入注册资本货币种类(万)',
					trigger: 'blur'
				}],
				foundDate: [{
					required: true,
					message: '请输入建立日期',
					trigger: 'blur'
				}],
				manageArea: [{
					required: true,
					message: '请输入经营范围',
					trigger: 'blur'
				}],
				yyZzSrc: [{
					required: true,
					message: '请输入营业执照图附件(以上是登记信息)',
					trigger: 'blur'
				}],
				zySf: [{
					required: true,
					message: '请输入主要身份',
					trigger: 'blur'
				}],
				jyXz: [{
					required: true,
					message: '请输入经营性质',
					trigger: 'blur'
				}],
				hyType: [{
					required: true,
					message: '请输入行业类型',
					trigger: 'blur'
				}],
				zyClass: [{
					required: true,
					message: '请输入主营品类',
					trigger: 'blur'
				}],
				shFwScope: [{
					required: true,
					message: '请输入送货服务范围',
					trigger: 'blur'
				}],
				gsGw: [{
					required: true,
					message: '请输入公司官网',
					trigger: 'blur'
				}],
				gsLogoSrc: [{
					required: true,
					message: '请输入公司Logo',
					trigger: 'blur'
				}],
				gsDetail: [{
					required: true,
					message: '请输入公司简介(以上是业务信息)',
					trigger: 'blur'
				}],
				invoiceHead: [{
					required: true,
					message: '请输入发票头',
					trigger: 'blur'
				}],
				swDjh: [{
					required: true,
					message: '请输入税务登记号',
					trigger: 'blur'
				}],
				khhName: [{
					required: true,
					message: '请输入开户行',
					trigger: 'blur'
				}],
				khhNumber: [{
					required: true,
					message: '请输入开户行账号',
					trigger: 'blur'
				}],
				swDjDz: [{
					required: true,
					message: '请输入税务登记地址',
					trigger: 'blur'
				}],
				swDjDh: [{
					required: true,
					message: '请输入税务登记电话',
					trigger: 'blur'
				}],
				sprEmail: [{
					required: true,
					message: '请输入收票人邮箱',
					trigger: 'blur'
				}],
				sprDh: [{
					required: true,
					message: '请输入收票人电话(以上是开票信息)',
					trigger: 'blur'
				}],
				qyXz: [{
					required: true,
					message: '请输入企业性质',
					trigger: 'blur'
				}],
				status: [{
					required: true,
					message: '请输入状态0启用1停用',
					trigger: 'blur'
				}],
			}
		}
	},
	methods:{
		// 表单重置
		reset: function () {
			this.form = {
				id: undefined,
				createTime: undefined,
				createUser: this.$store.getters['user/user'].id,
				name: undefined,
				rzRegion: undefined,
				tyShXxCode: undefined,
				englishName: undefined,
				qyShort: undefined,
				orgJgCode: undefined,
				dbsCode: undefined,
				qyTyoe: undefined,
				taxpayerSign: undefined,
				country: undefined,
				address: undefined,
				legalPerson: undefined,
				zcCapital: undefined,
				zcCurrency: undefined,
				foundDate: undefined,
				manageArea: undefined,
				yyZzSrc: undefined,
				zySf: undefined,
				jyXz: undefined,
				hyType: undefined,
				zyClass: undefined,
				shFwScope: undefined,
				gsGw: undefined,
				gsLogoSrc: undefined,
				gsDetail: undefined,
				invoiceHead: undefined,
				swDjh: undefined,
				khhName: undefined,
				khhNumber: undefined,
				swDjDz: undefined,
				swDjDh: undefined,
				sprEmail: undefined,
				sprDh: undefined,
				qyXz: undefined,
				status: 0,
			}
			if (this.$refs["form"] !== undefined) {
				this.$refs["form"].resetFields();
			}
		},
		submitForm() {
			let _this = this;
			_this.$refs['form'].validate((valid) => {
				if (valid) {
					if (_this.form.id != undefined) {
						editSupplierInfo(_this.form).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.openDialog = false;
								_this.$emit('callback',{type:1})
								// _this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					} else {
						addSupplierInfo(_this.form).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.openDialog = false;
								_this.$emit('callback',{type:2})
								// _this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					}
				}
			});
		},
		handleAvatarSuccess(res, file) {
			if (res.code == 0) {
				this.$success(res.msg);
				if (this.form.yyZzSrc != "" && this.form.yyZzSrc != undefined) {
				//如果修改附件 则删除原来的附件
				if (this.form.yyZzSrc != res.data.url) {
					this.delFile(this.form.yyZzSrc);
				}
				}
				this.form.yyZzSrc = res.data.url;
			}
		},
		beforeAvatarUpload(file) {
			//      let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) {
				this.$fail('上传附件大小不能超过 2MB!');
			}
			return isLt2M;
		},
	}
}
</script>
<style scoped="scoped">
	/** * 全屏弹框 不滚动 */
	.el-dialog__wrapper {
		overflow: hidden;
	}
	.newDialog ::v-deep .el-dialog__body {
		overflow: auto;
		height: calc(100vh - 160px);
		/*头+padding10 +加尾+padding10 + 2px 边框*/
	}
</style>


